<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="96px" height="20px" viewBox="0 0 96 20" enable-background="new 0 0 96 20" xml:space="preserve">  <image id="image0" width="96" height="20" x="0" y="0"
    xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAAUCAYAAAByKzjvAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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" />
</svg>
</template>

<script>
export default {};
</script>
